import { Container, Grid, Typography, ListItem, ListItemText, makeStyles} from '@material-ui/core'
import React, { useState } from 'react';
import {Link} from 'react-scroll';
import {animateScroll as scroll} from 'react-scroll';
import Nav from './Nav';
import logo from '../../images/logo_white.png';
import EmailIcon from '@material-ui/icons/Email';

const useStyles = makeStyles({
  hover: {
    paddingLeft: "0",
    '&:hover': {
      color: "#1F94C2"
    }
  }
})

function Footer(props) {

    const classes = useStyles();
    const {kontakt} = props
    
    console.log(kontakt)
    
    return (
       
        <Container style={{backgroundColor:"#060C22",padding: "50px",maxWidth:"100%",marginTop:"20px",color:"white"}}>
           <Grid
              container
              direction="row"
              justify="space-around"
              
              
              
            >
              <Grid item lg={3} xs={12}>
                <img src={logo} width="100px"/>{" "}
                {/* TODO FIX THIS and Menu icon below 960px  */}
                <Typography>
                Matematičko društvo "Istra"
                </Typography>
                <Typography>
                Dragonja 10, 52100 Pula 
                </Typography>
                <Typography>
                IBAN: HR9523600001102141663 
                </Typography>
                <Typography>
                OIB: 25524820734 
                </Typography>
              </Grid>

              <Grid item lg={3} xs={12}>
                  <Typography style={{color:"#1F94C2",fontSize:"20px"}}>LINKOVI</Typography>
                  <hr></hr>
                  <ListItem button component={Link} to="pocetna"
                  smooth={true} duration={500} spy={true} exact='true' offset={-80}
                  className={classes.hover}
                  >
                    <ListItemText >
                      Početna
                    </ListItemText>
                  </ListItem>
                  <ListItem button component={Link} to="about"
                  smooth={true} duration={500} spy={true} exact='true' offset={-80}
                  className={classes.hover}>
                    <ListItemText>
                      O konferenciji
                    </ListItemText>
                  </ListItem>
                  <ListItem button component={Link} to="presenters"
                  smooth={true} duration={500} spy={true} exact='true' offset={-80}
                  className={classes.hover}>
                    <ListItemText>
                      Izlagači
                    </ListItemText>
                  </ListItem>
                  <ListItem button component={Link} to="raspored"
                  smooth={true} duration={500} spy={true} exact='true' offset={-80}
                  className={classes.hover}>
                    <ListItemText>
                      Raspored
                    </ListItemText>
                  </ListItem>
                  <ListItem button component={Link} to="slike"
                  smooth={true} duration={500} spy={true} exact='true' offset={-80}
                  className={classes.hover}>
                    <ListItemText>
                      Slike
                    </ListItemText>
                  </ListItem>
                  <ListItem button component={Link} to="kontakt"
                  smooth={true} duration={500} spy={true} exact='true' offset={-80}
                  className={classes.hover}>
                    <ListItemText>
                      Kontakt
                    </ListItemText>
                  </ListItem>
               
              </Grid>
              <Grid item lg={3} xs={12}>
                <Typography style={{color:"#1F94C2",fontSize:"20px"}}>
                KONTAKT
                </Typography>
                <hr></hr>
                <Typography>

                <Typography>
                 Adresa: {kontakt[0].value}
                </Typography>

                
               
                <Typography>
                Telefon:{kontakt[1].value}
                </Typography>
                
                
                <Typography>
                Email:{kontakt[2].value}
                </Typography>

                <Typography>
                Republika Hrvatska
                </Typography>
               
  
                </Typography>
              </Grid> 
              </Grid>

              <Typography alignContent="center" style={{textAlign:"center",marginTop:"50px",maxWidth:"100%"}}>© Copyright MDI. All Rights Reserved</Typography>
              </Container>
              
              
    )
}

export default Footer
